import { MutableRefObject, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import Select from 'react-select';

export type CostOption = {
    label: string | null | undefined;
    value: number | string | null | undefined;
    key: number | string | null | undefined;
    data: any;
};

type CostSelectCellProps = {
    options: CostOption[];
    selectedKey: number | string;
    // onSelect: (key: string) => void;
    onSelect: (key: CostOption | null) => void;
    disabled?: boolean;
    rowIndex: number;
    colIndex: number;
    cellInputRefs?: MutableRefObject<{
        [key: string]: unknown;
    }>;
    handleArrowKeyDown?: (e: React.KeyboardEvent, itemId: any, rowIndex: any, colIndex: any) => void;
};

const CostSelectCell = ({
    options,
    selectedKey,
    onSelect,
    disabled = false,
    rowIndex,
    colIndex,
    cellInputRefs,
    handleArrowKeyDown,
}: CostSelectCellProps) => {
    const { t } = useTranslation();
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <StyledReactSelect
            isDisabled={disabled}
            menuIsOpen={menuOpen}
            onMenuOpen={() => setMenuOpen(true)}
            onMenuClose={() => setMenuOpen(false)}
            options={options}
            value={options.find((o) => o.data.id === selectedKey) || null}
            placeholder={t('selectAdditionalCost')}
            ref={(el) => {
                if (cellInputRefs) {
                    cellInputRefs.current[`additionalCosts-${rowIndex}-${colIndex}`] = el;
                }
            }}
            onChange={(selectedOption) => {
                // const option = selectedOption as { value: string; label: string } | null;
                const option = selectedOption as CostOption | null;
                // onSelect(option?.value ?? '');
                onSelect(option ?? null);
                setMenuOpen(false);
            }}
            menuPortalTarget={document.body}
            tabIndex={-1}
            onKeyDown={(e: React.KeyboardEvent) => {
                if (e.key === 'Enter' && !menuOpen) {
                    e.preventDefault();
                    e.stopPropagation();
                    setMenuOpen(true);
                    return;
                }
                if (e.key === 'Escape' && menuOpen) {
                    e.preventDefault();
                    e.stopPropagation();
                    setMenuOpen(false);
                    return;
                }
                if (!menuOpen) {
                    handleArrowKeyDown?.(e, 'additionalCosts', rowIndex, colIndex);
                }
            }}
        />
    );
};

export default CostSelectCell;

const StyledReactSelect = styled(Select)`
    display: flex;
    min-width: 0;
    flex: 1;
    height: 37px;
    white-space: nowrap;

    > * {
        width: auto !important;
        min-width: 100% !important;
    }
`;
